import React, { Component } from "react";
import { observer } from "mobx-react";
import SettingDefaultLeftView from "./components/layouts/SettingDefaultLeftView";
import SettingDefaultSelfDeliveryItemView from "./sub/SettingDefaultSelfDeliveryItemView";
import DefaultSelfDeliveryLayer from "../main/body/layer/DefaultSelfDeliveryLayerView";
import { fn_deliverySelf } from "../../function/FnBodyLayer";
import { Link } from "react-router-dom";

@observer
class SettingDefaultSelfDeliveryView extends Component {
  render() {
    const { rootStore } = this.props;
    const settingStore = rootStore.settingStore;
    const deliveryAspList = rootStore.deliveryStore.getDeliveryAsp;
    settingStore.setSettingUseMenu("self_delivery");
    settingStore.setSettingView(false);

    return (
      <>
        <div className="article_setting">
          {/*왼쪽 메뉴 */}
          <SettingDefaultLeftView rootStore={rootStore} />

          <div className="section_content">
            <h3>자체배달원 관리</h3>
            <div className="scroll">
              <div className="inner">
                <div className="wrap_delivery">
                  <div className="box_tit">
                    <h4>자체배달원 목록</h4>
                    <button type="button" className="btn_add" onClick={event => fn_deliverySelf(rootStore, null)}>
                      <span>추가</span>
                    </button>
                  </div>
                  <ul className="list_self_delivery">
                    {Array.isArray(deliveryAspList) && deliveryAspList.length > 0
                      ? deliveryAspList.map(obj => (
                          <SettingDefaultSelfDeliveryItemView key={obj.emp_no} rootStore={rootStore} obj={obj} />
                        ))
                      : null}
                  </ul>
                  {deliveryAspList.length <= 0 ? (
                    <div className="box_self_delivery_none">
                      <div className="tit">
                        <strong>등록된 배달사원이 없습니다</strong>
                      </div>
                      <p>[추가]버튼을 눌러 배달사원을 등록해주세요</p>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="close">
                <Link to="/">
                  <button type="button">
                    <span>페이지 닫기</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <DefaultSelfDeliveryLayer rootStore={rootStore} />
      </>
    );
  }
}

export default SettingDefaultSelfDeliveryView;
